import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDocumentsStatistics } from "../../store/documentStatistics/actions";
export var GetDocumentsStatistics = function (trigger) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        loadingDocumentStatistics: state.DocumentStatistics.loadingDocumentStatistics,
        responseDocumentStatistics: state.DocumentStatistics.responseDocumentStatistics,
        errorDocumentStatistics: state.DocumentStatistics.errorDocumentStatistics,
    }); }), loadingDocumentStatistics = _a.loadingDocumentStatistics, responseDocumentStatistics = _a.responseDocumentStatistics, errorDocumentStatistics = _a.errorDocumentStatistics;
    useEffect(function () {
        if (trigger) {
            dispatch(getDocumentsStatistics());
        }
    }, [trigger]);
    return {
        loadingDocumentStatistics: loadingDocumentStatistics,
        responseDocumentStatistics: responseDocumentStatistics,
        errorDocumentStatistics: errorDocumentStatistics,
    };
};
